import { Component, OnInit } from '@angular/core';
import { MessageService } from '../typewriter/output/MessageController';
import { MessageDto } from '../typewriter/output/MessageDto';
import { MessageResponseDto } from '../typewriter/output/MessageResponseDto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  submit: Observable<any>;
  message: MessageDto = { senderName: '', senderEmail: '', subject: '', content: '', id: null };
  response: MessageResponseDto;
  subject = '';
  sending = false;

  constructor(private messageService: MessageService) { }

  ngOnInit() {
    this.message.subject = this.subject;
  }

  sendMessage() {
    this.sending = true;
    this.submit = Observable.fromPromise(
      this.messageService.post(this.message)
        .then(response => {
          this.response = response;
          this.sending = false;
        })
        .catch(() => {
          this.sending = false;
        })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts